export default __webpack_public_path__ + "static/media/YFL.03ea94be.png";